// extracted by mini-css-extract-plugin
module.exports = {"material-balance-wrapper":"MixedBlance_material-balance-wrapper__4sIhS"};